import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  container: {
    position: "fixed",
    top: 70,
    left: theme.spacing(26),
    padding: "0 20px",
    backgroundColor: theme.palette.secondary.main,
    width: "100%",
    height: 53,
    zIndex: 1200,
  },
  link: {
    textDecoration: "none",
  },
  banner: {
    color: colors.white,
    fontSize: 20,
    fontWeight: "bold",
    lineHeight: "53px",
  },
}));

export default useStyles;
